import { useState } from "react"
import type { FaqItem } from "../../data/faq"
import EditableText from "../ui/EditableText"

interface FaqAccordionProps {
  items: FaqItem[]
  editable?: boolean
  onSaveQuestion?: (index: number, value: string) => void
  onSaveAnswer?: (index: number, value: string) => void
}

export default function FaqAccordion({
  items,
  editable = false,
  onSaveQuestion,
  onSaveAnswer,
}: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <div className="mt-8 border-t border-dantzBlue/40">
      {items.map((item, index) => (
        <div key={index} className="border-b border-dantzBlue/40">
          <div className="flex w-full items-center justify-between gap-4 py-4 text-left">
            {editable ? (
              <EditableText
                as="span"
                value={item.question}
                editMode
                onSave={(value) => onSaveQuestion?.(index, value)}
                className="block flex-1 text-[18px] leading-snug tracking-wide text-dantzBlue"
              />
            ) : (
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="flex flex-1 items-center justify-between gap-4 text-left"
                aria-expanded={openIndex === index}
              >
                <span className="text-[18px] leading-snug tracking-wide text-dantzBlue">
                  {item.question}
                </span>
              </button>
            )}
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              aria-expanded={openIndex === index}
              aria-label="Toggle answer"
            >
              <img
                src="/images/XpressIPIconFaq.svg"
                alt=""
                className={`h-6 w-6 shrink-0 transition-transform duration-200 ${
                  openIndex === index ? "-scale-y-100" : ""
                }`}
              />
            </button>
          </div>

          {(openIndex === index || editable) && (
            <div className="border-t border-dantzBlue/40 py-5">
              {editable ? (
                <EditableText
                  as="p"
                  value={item.answer}
                  editMode
                  multiline
                  onSave={(value) => onSaveAnswer?.(index, value)}
                  className="block text-sm leading-relaxed text-dantzBlue"
                />
              ) : (
                <p className="text-sm leading-relaxed text-dantzBlue">{item.answer}</p>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
